export const modalPT = {
  notification_mark_to_read: 'Marcar como lido',
  notification_mark_to_read_for: 'Marcar como lido por',
  notification_mark_to_read_day: 'dia',
  notification_mark_to_read_days: 'dias',
}
